import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import axios from "axios";
import { toast } from "react-toastify";
import Tab from "@mui/material/Tab";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Card,
  Backdrop,
  CardContent,
  Divider,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AsyncSelect from "react-select/async";
import CreateCase from "../../components/createCase";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import DonutChart from "../../components/donutchart";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import CaseTable from "../../components/caseTable";
import {
  filterLegalDiscoveries,
  getLegalDiscoveries,
} from "../../functions/apicall";
import { Col, Container, Row } from "react-bootstrap";
import get from "lodash/get";
import { useNavigate } from "react-router-dom";
import { parse } from "query-string";
import { debounce } from "lodash";
import { PAGE_SIZE, TIMEOUT_MS } from "../../utilities/constants";
import { useQuery } from "@tanstack/react-query";
import Box from "../../components/base/Box";

export default function Details() {
  const location = useLocation();
  const queryParams = parse(location.search);
  const [searchParams, setSearchParams] = useSearchParams()
  const [rowData, setRowData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [totalRows, setTotalRows] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [totalCases, setTotalCases] = useState(null);
  const [totalFavorites, setTotalFavorites] = useState(null);
  const [page, setPage] = useState(get(queryParams, 'page', 1));
  const [showFavorites, setShowFavorites] = useState(get(queryParams, 'favorites', '') === 'true');
  const [value, setValue] = useState(showFavorites ? 1 : 0);
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState(
    get(queryParams, 'search', "")
  );
  const [searchLoading, setSearchLoading] = useState(false);

  const setCurrentPage = (pageNumber) => {
    setLoading(true)
    setPage(pageNumber)
    setSearchParams({page: pageNumber, search: searchValue || "", favorites: showFavorites}, {replace: true})
  }

  const onSearchChange = (value) => {
    setSearchLoading(true);
    setSearchValue(value);
    setPage(1);
    setSearchParams(
      { search: value, favorites: showFavorites },
      { replace: true }
    );
  };
  const debouncedOnSearchChange = debounce(onSearchChange, 500);

  const casesQuery = useQuery(
    ["cases", page, showFavorites, searchValue],
    () => {
      const userData = JSON.parse(localStorage.getItem("user"));
      const body = {
        user_id: userData.sub,
        case_type: showFavorites ? "favorite" : "all",
        filter_type: "case_name",
        filter_value: searchValue,
      };
      return filterLegalDiscoveries(page, PAGE_SIZE, body, true);
    },
    {
      onSuccess: (legalData) => {
        setTotalRows(legalData.totalItems);
        setTotalCases(legalData.totalCases);
        setTotalFavorites(legalData.totalFavoritesCases);
        setTotalPages(legalData.totalPages);
        let chngRowData = [];
        if (
          legalData.all_cases_list &&
          Array.isArray(legalData.all_cases_list)
        ) {
          chngRowData = legalData.all_cases_list.map((row) => ({
            id: row.case_id,
            name: row.case_name,
            type: row.case_type,
            owner: get(row, "owner_info.name", "-"),
            status: row.status.toLowerCase(),
            score: row.sentiment_score,
            no: row.total_documents,
            date: row.creation_date,
          }));
        }
        setRowData(chngRowData);
        setSearchLoading(false);
        setLoading(false);
      },
      refetchInterval: TIMEOUT_MS,
    }
  );

  useEffect(() => {
    if (rowData && setTotalRows) {
      setLoading(false);
    }
  }, [rowData, totalRows]);

  return (
    <>
      {loading ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: "1500" }}
          open={loading}
          // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Grid container spacing={2} className="maindivpage">
          <CreateCase
            refreshData={() => {
              setLoading(true)
              setPage(1);
              setSearchParams({}, {replace: true})
              casesQuery.refetch()
            }}
            open={open}
            setOpen={setOpen}
          />
          <Grid md={12} sm={12} xs={12} lg={12} className="gridSub">
            <Box sx={{ borderBottom: 1, borderColor: "#E2E2E2", marginTop: 4 }}>
              <Tabs
                value={value}
                onChange={(event, newTabIndex) => {
                  setLoading(true)
                  setSearchValue("");
                  if (newTabIndex == 0) {
                    // setRowData([...caseData]);
                    setShowFavorites(false);
                    setSearchParams({}, {replace: true})
                  } else {
                    // setRowData([]);
                    setShowFavorites(true);
                    setSearchParams({favorites: true}, {replace: true})
                  }
                  setPage(1);
                  setValue(newTabIndex);
                }}
                aria-label="basic tabs example"
                sx={{
                  "& .MuiTabs-indicator": { backgroundColor: "#0065c9" },
                  "& .Mui-selected": {
                    color: "#0065c9 !important",
                    textTransform: "capitalize",
                  },
                  "& .MuiTab-root": {
                    color: "#402E46",
                    textTransform: "capitalize",
                  },
                }}
              >
                <Tab
                  label={
                    <Box sx={{display: "flex", gap: "5px", alignItems: "center"}}>
                      <Box>All legal discoveries</Box>
                      <Box sx={{backgroundColor: "#e6f0f4", borderRadius: "50%", padding: "7px", color: "black"}}>
                        {totalCases}
                      </Box>
                    </Box>
                  }
                  value={0}
                />
                <Tab
                  label={
                    <Box sx={{display: "flex", gap: "5px", alignItems: "center"}}>
                      <Box>My Favorites</Box>
                      <Box sx={{backgroundColor: "#e6f0f4", borderRadius: "50%", padding: "8px", color: "black"}}>
                        {totalFavorites}
                      </Box>
                    </Box>
                  }
                  value={1} />
              </Tabs>
            </Box>
            <Grid container>
              <Grid md={8} lg={8} sm={12} xs={12}>
                <TextField
                  className="detailsearch"
                  id="input-with-icon-textfield"
                  onChange={(e) => {
                    debouncedOnSearchChange(e.target.value)
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      const value = document.getElementById("input-with-icon-textfield").value
                      setSearchValue(value);
                      setPage(1);
                      setSearchParams({search: value, favorites: showFavorites}, {replace: true})
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  defaultValue={searchValue}
                  placeholder="Search by case name"
                  variant="outlined"
                />
              </Grid>
              <Grid md={4} lg={4} sm={12} xs={12} align="right">
                <Button
                  sx={{ boxShadow: "0px 13px 32px #00000029" }}
                  className="caseCreatedBtn"
                  onClick={() => setOpen(true)}
                >
                  <AddIcon className="caseAddIcn" />
                  CREATE
                </Button>
              </Grid>
            </Grid>
            <Grid style={{ marginTop: 20 }}>
              {rowData && rowData.length > 0 ? (
                <>
                  {searchLoading ? (
                    <CircularProgress
                      color="inherit"
                      sx={{
                        mt: 8,
                        display: "flex",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    />
                  ) : (
                    <CaseTable
                      rowData={rowData}
                      totalRows={totalRows}
                      getPage={setCurrentPage}
                      currentPage={page}
                      totalPages={totalPages}
                    />
                  )}
                </>
              ) : (
                <Grid>
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "10%",
                      lineHeight: 2,
                      fontWeight: "100",
                    }}
                  >
                    It seems there is nothing here! <br /> You might want to
                    create a new case.
                  </p>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}
